import { css } from '@emotion/react'

import useClientInfo from '../services/useClientInfo'
import { mapChildren, enlargeButtonLike } from './Button'
import Grid from './Grid'

export default function Poster(props: {
  photo: string
  title: React.ReactNode
  description: React.ReactNode
  buttons: React.ReactNode
}) {
  const clientInfo = useClientInfo()

  const photoDimension = clientInfo.isMobile()
    ? '200px' // Fit an iPhone 5 screen without a vertical scrollbar
    : '270px'

  return (
    <Grid
      spacing={clientInfo.isMobile() ? 20 : 40}
      css={css`
        align-items: center;
        text-align: center;
        align-self: center;
        max-width: 540px; /* Enforce word wrap */
      `}
    >
      <Grid.Row
        style={{
          marginTop: 'auto',
        }}
      >
        <img
          css={css`
            display: inline-block;
            width: 100vw;
            max-width: ${photoDimension};
            max-height: ${photoDimension};
          `}
          src={props.photo}
        />
      </Grid.Row>

      <Grid.Row>
        <Grid spacing={20}>
          <Grid.Row>
            <h1
              css={css`
                font-size: 24px;
                font-weight: 600;
                line-height: 1;
                margin: 0;
              `}
            >
              {props.title}
            </h1>
          </Grid.Row>

          <Grid.Row>
            <p
              css={css`
                font-size: ${clientInfo.isMobile() ? '14px' : '16px'};
                line-height: 1.5;
                margin: 0;
              `}
            >
              {props.description}
            </p>
          </Grid.Row>
        </Grid>
      </Grid.Row>

      <Grid.Row
        css={css`
          width: 100%;
          max-width: 360px;
        `}
        style={
          clientInfo.isMobile()
            ? { marginTop: 'auto' }
            : { marginBottom: 'auto' /* Render the buttons at the bottom of the screen */ }
        }
      >
        <Grid spacing={10}>
          {mapChildren(props.buttons, (element, index) => (
            <Grid.Row key={element.key ?? index}>{enlargeButtonLike(element, 'stretch')}</Grid.Row>
          ))}
        </Grid>
      </Grid.Row>
    </Grid>
  )
}
